import React from "react";

const CRM = React.createContext({language: "DE"});

export default CRM;
